<template>
  <div ref="Crud" :crudmodel="crudmodel" :crudtitle="crudtitle" :gmapautosyncbyrow="gmapautosyncbyrow"
       :parmscustom="parmscustom">
    <JqxLoader ref="jqxLoader"
               :imagePosition="'top'"
               :width="100"
               :height="60">
    </JqxLoader>
    <JqxGrid v-if="rowsData.length > 0 && !noData" ref="myGrid" :theme="'material'"
             :height="'900px'" :source="dataAdapter"
             :columns="columns"
             :width="'100%'" :columnsresize="true"
             :editable="false" :altrows="true"
             :filterable="true" :autoshowfiltericon="true"
             :showtoolbar="true" :rendertoolbar="rendertoolbar"
             :sortable="true"
             :filtermode="'excel'" :virtualmode="virtualMode" :rendergridrows="rendergridrows" :pageable="true"
             :pagermode="'default'"
             :pagesize="100" :pagesizeoptions=" [100,1000,1000000] " @rowselect="onRowselect($event)"
             :selectionmode="'checkbox'" :showfilterrow="true" @pagechanged="onPagechanged($event)"
             :sorttogglestates="2"
             :enablebrowserselection="true"
             @pagesizechanged="onPagesizechanged($event)">
    </JqxGrid>
    <div v-else-if="rowsData.length === 0 && !noData">
      <JqxButton style="margin: 20px; display: block" :width="100" @click="clearFilters()">Rimuovi i filtri</JqxButton>
      <JqxButton style="margin: 20px; display: block" :width="100" @click="firstEntities()">Inserisci prima entità
      </JqxButton>
    </div>
    <JqxGrid v-else-if="rowsData.length === 0 && noData" ref="myGrid" :theme="'material'"
             :height="'900px'" :source="dynamicDataAdapter"
             :columns="columns"
             :width="'100%'" :columnsresize="true"
             :editable="false" :altrows="true"
             :filterable="true" :autoshowfiltericon="true"
             :showtoolbar="true" :rendertoolbar="rendertoolbar"
             :sortable="true"
             :filtermode="'excel'" :virtualmode="true" :rendergridrows="rendergridrows" :pageable="true"
             :pagermode="'default'"
             :pagesize="100" :pagesizeoptions=" [100] " @rowselect="onRowselect($event)"
             :selectionmode="'checkbox'" :showfilterrow="true" @pagechanged="onPagechanged($event)"
             :sorttogglestates="2"
             :enablebrowserselection="true"
             @pagesizechanged="onPagesizechanged($event)">
    </JqxGrid>
    <VettoriDetails ref="details" v-if="crudmodel === 'AnagraficaVettori'"></VettoriDetails>
    <ClientiDetails ref="details" v-else-if="crudmodel === 'AnagraficaClienti'"></ClientiDetails>
    <ArticoliDetails ref="details" v-else-if="crudmodel === 'AnagraficaArticoli'"></ArticoliDetails>
    <ImpiantiDetails ref="details" v-else-if="crudmodel === 'AnagraficaImpianti'"></ImpiantiDetails>
    <UbicazioniDetails ref="details" v-else-if="crudmodel === 'AnagraficaUbicazioni'"></UbicazioniDetails>
    <StockDetails ref="details" v-else-if="crudmodel === 'AnagraficaTipoStock'"></StockDetails>
    <PickingDetails ref="details" v-else-if="crudmodel === 'AnagraficaTipoPicking'"></PickingDetails>
    <DocumentiDetails ref="details" v-else-if="crudmodel === 'AnagraficaTipoDocumenti'"></DocumentiDetails>
    <UtentiDetails ref="details" v-else-if="crudmodel === 'User'"></UtentiDetails>
    <IngressiDetails ref="details" v-else-if="crudmodel === 'GestioneIngressi'"></IngressiDetails>
    <GiacenzeDetails ref="details" v-else-if="crudmodel === 'GestioneGiacenze'"></GiacenzeDetails>
    <UsciteDetails ref="details" v-else-if="crudmodel === 'GestioneUscite'"></UsciteDetails>
    <AttesaEdiDetails ref="details" v-else-if="crudmodel === 'ManagerTrasmissioniEdi'"></AttesaEdiDetails>
    <ArchivioSpedizioniDetails ref="details"
                               v-else-if="crudmodel === 'ArchivioSpedizioni' && parmscustom === 'false'"></ArchivioSpedizioniDetails>
    <ArchivioSpedizioniEditDetails ref="details"
                                   v-else-if="crudmodel === 'ArchivioSpedizioni' && parmscustom === 'modifica'"></ArchivioSpedizioniEditDetails>
  </div>
</template>

<script>
//Declare standard import comonent
import JqxGrid from "~jqx/jqwidgets-vue/vue_jqxgrid.vue";
import {mapGetters} from 'vuex';
import VettoriDetails from "./cruddetails/VettoriDetails";
import ClientiDetails from "./cruddetails/ClientiDetails";
import ArticoliDetails from "./cruddetails/ArticoliDetails";
import ImpiantiDetails from "./cruddetails/ImpiantiDetails";
import UbicazioniDetails from "./cruddetails/UbicazioniDetails";
import StockDetails from "./cruddetails/StockDetails";
import PickingDetails from "./cruddetails/PickingDetails";
import DocumentiDetails from "./cruddetails/DocumentiDetails";
import UtentiDetails from "./cruddetails/UtentiDetails";
import IngressiDetails from "./cruddetails/IngressiDetails";
import GiacenzeDetails from "./cruddetails/GiacenzeDetails";
import UsciteDetails from "./cruddetails/UsciteDetails";
import ArchivioSpedizioniDetails from "./cruddetails/ArchivioSpedizioniDetails";
import ArchivioSpedizioniEditDetails from "./cruddetails/ArchivioSpedizioniEditDetails";
import AttesaEdiDetails from "./cruddetails/AttesaEdiDetails";
import JqxButton from '~jqx/jqwidgets-vue/vue_jqxbuttons.vue';
import JqxLoader from "~jqx/jqwidgets-vue/vue_jqxloader.vue";

// Declare axios
const axios = require('axios');
//Declare global reference JS
let colonnegenerali = {};
let table;
let lastid = null;
let fieldnotallowed = null;
let alldata = null;
let newrow = false;
let source;

export default {
  name: "Crud",
  components: {
    AttesaEdiDetails,
    ArchivioSpedizioniEditDetails,
    UsciteDetails,
    GiacenzeDetails,
    IngressiDetails,
    UtentiDetails,
    DocumentiDetails,
    PickingDetails,
    StockDetails,
    UbicazioniDetails,
    ArticoliDetails,
    ClientiDetails,
    JqxGrid,
    VettoriDetails,
    ImpiantiDetails,
    ArchivioSpedizioniDetails,
    JqxButton,
    JqxLoader
  },
  props: {
    crudtitle: {type: String, default: 'Anagrafica Vettori'},
    crudmodel: {type: String, default: 'Articoli'},
    parmscustom: {type: String, default: 'false'},
    gmapautosyncbyrow: Boolean
  },
  data: function () {
    return {
      theme: "theme",
      rowsData: [],
      dataAdapter: {},
      goColumns: true,
      columns: null,
      goRowData: false,
      noData: false,
      dynamicDataAdapter: {},
      virtualMode: true,
      exportData: false,
      interval: false,
      authExport: false
    }

  },
  computed: mapGetters({
    user: 'auth/user',
    //position: 'position/pos'
  }),
  beforeDestroy: function () {
    //console.log("Before Destroy (in crud)!");
    try {
      if (this.$refs.details.$refs.myWindow) {
        this.$refs.details.$refs.myWindow.destroy();
      }
    } catch (error) {
      //console.log(error);
    }
  },
  methods: {
    rendergridrows: function (params) {
      if (!this.goRowData) return;
      let data = this.generateData(params.startindex, params.endindex, params);
      return data;
    },
    onPagechanged: function () {
      this.$refs.myGrid.updatebounddata();
    },
    firstEntities: function () {
      this.noData = true;
    },
    clearFilters: () => {
      window.location.reload();
    },
    onPagesizechanged: function (event) {
      this.$refs.myGrid.updatebounddata();
      //event.stopPropagation()
    },
    generateData: function (startindex, endindex, params) {
      //console.log(params, "PARAMS")
      // //console.log('SOUCE! --', JSON.parse(JSON.stringify(this.rowsData)));
      if (this.rowsData.length < 1) return;
      let data = {};

      for (let i = startindex; i < endindex; i++) {
        if (this.rowsData.length < i + 1) break;
        let row = JSON.parse(JSON.stringify(this.rowsData[i]));
        // console.log(row, "row prima");
        try {
          if (this.exportData) {
            for (let k in row) {
              if(k.includes('data') && this.isDate(row[k])) {
                // Dividi la stringa in anno, mese e giorno
                const [year, month, day] = row[k].split("-");
                row[k] = `${day}/${month}/${year}`;
              }
            }
          }
        } catch (e) {
          console.log(e, "conversione data non riuscita")
        }
        data[i] = row;
      }
      this.authExport = true;
      //console.log(data)
      return data;
    },
    isDate: function (dateStr) {
      if (isNaN(dateStr)) { //Checked for numeric
        let dt = new Date(dateStr);
        if (isNaN(dt.getTime())) { //Checked for date
          return false; //Return string if not date.
        } else {
          return true; //Return date **Can do further operations here.
        }
      } else {
        return false; //Return string as it is number
      }
    },
    onRowselect: function (event) {
      let bowrow = this.$refs.myGrid.getselectedrowindex();
      ////console.log(bowrow);
      if (!this.gmapautosyncbyrow || bowrow == -1)
        return false;
      let data = this.$refs.myGrid.getrowdata(bowrow);
      let loc = '';
      if (data.localita)
        loc = data.localita;
      let addresformaps = data.ragione_sociale + " " + loc;
      document.getElementById("pac-input").value = addresformaps;
      let tmp = document.getElementById('pac-input');
      google.maps.event.trigger(tmp, 'focus', {});
    },
    rendertoolbar: function (toolbar) {
      let container = document.createElement('div');
      container.style.margin = '5px';
      let buttonContainer1 = document.createElement('div');
      buttonContainer1.id = 'buttonContainer1';
      buttonContainer1.style.cssText = 'float: left; margin-right:5px;';
      container.appendChild(buttonContainer1);
      let buttonContainer2 = document.createElement('div');
      buttonContainer2.id = 'buttonContainer2';
      buttonContainer2.style.cssText = 'float: left';
      container.appendChild(buttonContainer2);
      let buttonContainer3 = document.createElement('div');
      buttonContainer3.id = 'buttonContainer3';
      buttonContainer3.style.cssText = 'float: left';
      container.appendChild(buttonContainer3);
      toolbar[0].appendChild(container);

      if (this.crudmodel !== 'GestioneGiacenze') {
        let addRowButton = jqwidgets.createInstance('#buttonContainer1', 'jqxButton', {
          width: 120,
          value: 'Inserisci nuovo',
          theme: 'material'
        });
        addRowButton.addEventHandler('click', (row) => {
          if (lastid != null) {
            lastid = parseInt(lastid) + 1;
          } else {
            lastid = 0;
          }
          //this.$refs.myGrid.addrow(lastid, {});
          newrow = true;
          this.editButtonCustom(lastid, alldata, true);
        });
      }

      let exportData = jqwidgets.createInstance('#buttonContainer3', 'jqxButton', {
        width: 120,
        value: 'Esporta in Excel',
        theme: 'material'
      });
      exportData.addEventHandler('click', async (row) => {
        try {
          this.$refs.jqxLoader.open();
          this.exportData = true;
          this.authExport = false;
          this.$refs.myGrid.updatebounddata();
          this.interval = setInterval(() => {
            try {
              if (!this.authExport) return;
              this.$refs.myGrid.exportdata('xls', 'jqxGrid', true, null, false, '/api/jqxcontrollers/dataexport');
              this.exportData = false;
              this.$refs.myGrid.updatebounddata();
              this.$refs.jqxLoader.close();
            } catch (e) {
              console.log(e)
              this.exportData = false;
              this.$refs.myGrid.updatebounddata();
              this.$refs.jqxLoader.close();
              alert("Spiacente! Non riesco ad esportare.")
            }
            clearInterval(this.interval)
          }, 1000)
        } catch (e) {
          this.exportData = false;
          this.$refs.myGrid.updatebounddata();
          this.$refs.jqxLoader.close();
          alert("Spiacente! Non riesco ad esportare.")
        }
      });

      let clearFilter = jqwidgets.createInstance('#buttonContainer2', 'jqxButton', {
        width: 200,
        value: 'Rimuovi ordinamento e filtri',
        theme: 'material'
      });
      clearFilter.addEventHandler('click', (row) => {
        this.$refs.myGrid.removesort();
        this.$refs.myGrid.clearfilters();
        this.$refs.myGrid.clearselection();
      });
    },
    pagerrenderer: function () {
      //this.$refs.myGrid.autoresizecolumns();
    },
    saveBtn: function (datagridparent = false) {
      let row = {};
      if (this.editrow >= 0) {
        for (let r = 0; r < colonnegenerali.length; r++) {
          let colonne = colonnegenerali[r].datafield;
          if (fieldnotallowed.includes(colonne)) {
            continue;
          }
          if (this.$refs.details.$refs[colonne] != undefined)
            row[colonne] = this.$refs.details.$refs[colonne].val();
          else if (this.$refs.details.$refs.autogoogle != undefined) {
            try {
              //let tmpval = this.$refs.details.$refs.autogoogle.$refs[colonne].val();
              let tmpval = this.$refs.details.$refs.autogoogle.$refs[colonne].val();
              row[colonne] = document.getElementsByName(colonne)[0].value;
              /*if (typeof tmpval === 'object')
                  row[colonne] = tmpval.value;
              else
                  row[colonne] = tmpval;*/
            } catch (e) {
              row[colonne] = this.$refs.details.$refs.autogoogle.$refs[colonne].value;
            }
          }
        }
        if (datagridparent)
          row['datagridparent'] = datagridparent;

        for (let r = 0; r < colonnegenerali.length; r++) {
          let colonne = colonnegenerali[r].datafield;
          if (fieldnotallowed.includes(colonne)) {
            continue;
          }
        }
        let rowID = this.$refs.myGrid.getrowid(this.editrow);
        let dataRecord = this.$refs.myGrid.getrowdata(this.editrow);
        let url = `/api/cruds/${rowID}`;
        if (newrow) {
          url = `/api/cruds/create`;
        }
        //console.log(rowID)
        axios.put(url, {
          t: table,
          id: rowID,
          data: row
        }).then(response => {
          newrow = false;
          //this.$refs.myGrid.updaterow(rowID, row);
          this.$refs.details.$refs.myWindow.hide();
          //this.dataCreationCustom();
          if (this.noData) {
            window.location.reload();
          }
          this.$refs.myGrid.updatebounddata();
        }).catch(error => {
          if (this.noData) {
            window.location.reload();
          }
          newrow = false;
          this.$refs.details.$refs.myWindow.hide();
          //this.dataCreationCustom();
          this.$refs.myGrid.updatebounddata();
          if (error.response && error.response.data.message == 'Salvataggio annullato: articolo già esistente.') alert(error.response.data.message)
          else alert(error);
        });
      }
    },
    editButtonCustom: function (row, data, newrow = false) {
      //get the data and append in to the inputs
      this.editrow = row;
      let dataRecord;
      if (newrow) {
        dataRecord = null;
      } else {
        dataRecord = this.$refs.myGrid.getrowdata(this.editrow);
      }
      for (let r = 0; r < data[0].columns.length; r++) {
        let colonne = data[0].columns[r].datafield;
        if (fieldnotallowed.includes(colonne)) {
          continue;
        }
        //this.$refs.details[colonne].val(dataRecord[colonne]);
        if (this.$refs.details.$refs[colonne] != undefined)
          if (newrow) {
            this.$refs.details.$refs[colonne].val(dataRecord);
          } else {
            this.$refs.details.$refs[colonne].val(dataRecord[colonne]);
          }
        else if (this.$refs.details.$refs.autogoogle != undefined)
          if (this.$refs.details.$refs.autogoogle.$refs[colonne] != undefined) {
            try {
              if (newrow) {
                this.$refs.details.$refs.autogoogle.$refs[colonne].val(dataRecord);
              } else {
                this.$refs.details.$refs.autogoogle.$refs[colonne].val(dataRecord[colonne]);
              }
            } catch (e) {
              if (newrow) {
                this.$refs.details.$refs.autogoogle.$refs[colonne].value = dataRecord;
              } else {
                this.$refs.details.$refs.autogoogle.$refs[colonne].value = dataRecord[colonne];
              }
            }
          }
      }
      if (this.crudmodel === "GestioneIngressi" || this.crudmodel === "GestioneUscite") {
        let stato;
        if (!newrow) {
          //console.log('/api/cruds/read?t=' + this.crudmodel + 'Corpo&q=id-' + this.$refs.myGrid.getrowid(this.editrow));
          this.$refs.details.newRowCheckGrid(0);
          this.$refs.details.$refs.DetailsIngressiUscite.$refs.myGridDetails.$parent.setQueryModel('/api/cruds/read?t=' + this.crudmodel + 'Corpo&q=id-' + this.$refs.myGrid.getrowid(this.editrow));
        } else {
          //console.log('this: ', this);
          this.$refs.details.newRowCheckGrid(1);
          this.$refs.details.$refs.DetailsIngressiUscite.$refs.myGridDetails.$parent.setQueryModel('/api/cruds/read?t=' + this.crudmodel + 'Corpo&q=refresh-');
        }
        ////this.$refs.details.$refs.DetailsIngressiUscite.$refs.myGridDetails.$parent.dataCreationCustomDetails();
        if (this.crudmodel === "GestioneIngressi") {
          stato = this.$refs.myGrid.getcellvalue(this.editrow, "stato_ingresso");
        } else {
          stato = this.$refs.myGrid.getcellvalue(this.editrow, "stato_missione");
        }
        this.$refs.details.$refs.DetailsIngressiUscite.$refs.myGridDetails.$parent.setStato(stato)
      }
      if (this.crudmodel === "AnagraficaArticoli") {
        if (!newrow && this.user.role !== 'admin') {
          this.$refs.details.newRowCheckGrid(0);
        } else {
          this.$refs.details.newRowCheckGrid(1);
        }
      }
      // show the popup window.
      //this.$refs.myWindow.position = 'top,center';
      this.$refs.details.$refs.myWindow.position = 'top,center';
      this.$refs.details.$refs.myWindow.open();
      //Popolo le date e valori eventuali di default
      if (newrow) {
        try {
          this.$refs.details.setDateCustom()
        } catch (err) {

        }
      }
      //Ordino le colonne come da default al momento della creazione tabella secondaria jqxDetailsIngressiUscite
      //Setto il tab in posizione 0 se esistente
      try {
        this.$refs.details.$refs.DetailsIngressiUscite.reorderColum();
        this.$refs.details.$refs.tab.select(0);

      } catch (err) {

      }

      //this.$refs.myWindow.open();
    },
    deleteButtonCustom: function (row) {
      //get the data and append in to the inputs
      if (confirm('Sicuro? Proseguo con l\'eliminazione?')) {
        this.deleterow = row;
        let rowID = this.$refs.myGrid.getrowid(this.deleterow);
        let del = axios.put(`/api/cruds/delete`, {
          id: rowID,
          t: table,
        }).then(() => {
          //this.$refs.myGrid.deleterow(rowID);
          //this.dataCreationCustom();
          this.$refs.myGrid.updatebounddata();
        });
      }
    },
    printUdcLabels: function (row) {
      let print_row = row;
      let rowID = this.$refs.myGrid.getrowid(print_row);
      let start = axios.get(`/api/stampe/labels/udc`, {
        params: {
          id: rowID,
          t: this.crudmodel
        }
      }).then((data) => {
        //console.log(data);
        if (data) {
          let getUrl = window.location;
          let baseurl = getUrl.origin;

          window.open(baseurl + data.data, 'Label', '_blank');
        }
      });
    },
    printDistinta: function (row, url) {
      let print_row = row;
      let rowID = this.$refs.myGrid.getrowid(print_row);
      let start = axios.get(url, {
        params: {
          id: rowID
        }
      }).then((data) => {
        //console.log(data.data);

        if (data) {
          let getUrl = window.location;
          let baseurl = getUrl.origin;

          window.open(baseurl + data.data, 'Label', '_blank');
        }
      });
    },
    sendEdi: function (row, url) {
      let single_row = row;
      let rowID = this.$refs.myGrid.getrowid(single_row);
      let start = axios.get(url, {
        params: {
          id: rowID
        }
      }).then((data) => {
        if (data.data.code === 200) {
          if (data.data.pdf) {
            let getUrl = window.location;
            let baseurl = getUrl.origin;
            window.open(baseurl + data.data.pdfPath, '_blank');
          } else {
            alert("Trasmissione effettuata")
          }
        } else {
          alert("ERRORE: " + data.data.errorMessage)

          if (data.data.pdf) {
            let getUrl = window.location;
            let baseurl = getUrl.origin;
            window.open(baseurl + data.data.pdfPath, '_blank');
          }

        }
      });
    },
    detailsCheck: function (row, data) {
      let rowdata = this.$refs.myGrid.getrowdata(row);
      //console.log(rowdata);
      if (data[5][rowdata.ordine] != undefined) {
        //console.log(data[rowdata.ordine]);
        // this.editButtonCustom(row, data);
        this.$refs.details.$refs.DetailsCheck.$refs.myGridDetails.$parent.setQueryModel('/api/cruds/read?t=GestioneCheck&q=numero_uscita-' + rowdata.ordine);
        this.$refs.details.$refs.DetailsCheck.$refs.myGridDetails.$parent.dataCreationCustomDetails();

        this.$refs.details.$refs.myWindow.position = 'top,center';
        this.$refs.details.$refs.myWindow.open();
      }
    },
    //SIAMO QUI NICHOLAS
    confirmEDIinAttesa: function () {
      const value = this.$refs.myGrid.getselectedrowindexes();
      let idSpedizioni = [];
      if (value.length > 0) {
        for (let i = 0; i < value.length; i++) {
          let data = this.$refs.myGrid.getrowdata(value[i]);
          idSpedizioni.push(data.id_spedizione);
        }
        //Chiamo il servizio di backend
        axios.get(`/api/edi/sendFinalConfirm`, {
          params: {
            id: idSpedizioni
          }
        }).then((data) => {
          if (data.data.code === 200) {
            alert("Trasmissione finale effettuata")
            //pdf
            let getUrl = window.location;
            let baseurl = getUrl.origin;

            window.open(baseurl + '/api/storage/stampe/edi/ediBRT.pdf', 'Label', '_blank');
            // window.open(baseurl + data.data.pdfPath, 'Label', '_blank');

            //this.dataCreationCustom();
            this.$refs.myGrid.updatebounddata();
          } else {
            alert("ERRORE: " + data.data.errorMessage);
            //console.log(data);
            if (data.data.pdf) {
              let getUrl = window.location;
              let baseurl = getUrl.origin;
              window.open(baseurl + '/api/storage/stampe/edi/ediBRT.pdf', 'Label', '_blank');
            }

            //this.dataCreationCustom();
            this.$refs.myGrid.updatebounddata();
          }
        });
      }
    },
    buildAccessoryColumnsCustom: function (data) {
      //console.log(this.user);
      //console.log(this.crudmodel);
      let a = {
        text: 'Edit', datafield: 'Edit', columntype: 'button', width: '50',
        cellsrenderer: () => {
          return 'Edit';
        },
        buttonclick: (row) => {
          newrow = false;
          this.editButtonCustom(row, data);
        }
      };
      let b = {
        text: 'Delete', datafield: 'Delete', columntype: 'button', width: '50',
        cellsrenderer: () => {
          return 'Delete';
        },
        buttonclick: (row) => {
          this.deleteButtonCustom(row);
        }
      };
      let g = {
        text: 'Stampa UDC', datafield: 'Print', columntype: 'button', width: '50',
        cellsrenderer: () => {
          return 'UDC';
        },
        buttonclick: (row) => {
          this.printUdcLabels(row);
        }
      };
      let t = {
        text: 'Stampa ingresso', datafield: 'Ingresso', columntype: 'button', width: '70',
        cellsrenderer: () => {
          return 'Ingresso';
        },
        buttonclick: (row) => {
          this.printDistinta(row, `/api/stampe/ingresso/distinta`);
        }
      };
      let z = {
        text: 'Stampa uscita', datafield: 'Uscita', columntype: 'button', width: '70',
        cellsrenderer: () => {
          return 'Uscita';
        },
        buttonclick: (row) => {
          this.printDistinta(row, `/api/stampe/uscita/distinta`);
        }
      };
      let n = {
        text: 'Stampa ddt', datafield: 'DDT', columntype: 'button', width: '70',
        cellsrenderer: () => {
          return 'DDT';
        },
        buttonclick: (row) => {
          this.printDistinta(row, `/api/stampe/spedizione/ddt`);
        }
      };
      let k = {
        text: 'Invia EDI', datafield: 'EDI', columntype: 'button', width: '70',
        cellsrenderer: () => {
          return 'EDI';
        },
        buttonclick: (row) => {
          this.sendEdi(row, `/api/edi/send`);
        }
      };
      let h = {
        text: 'Check', datafield: 'Check', columntype: 'button', width: '70',
        cellsrenderer: (row, columnsfield, value, defaulthtml, columnproperties, rowdata) => {
          //console.log("data: ", data);
          //console.log("rowdata: ", rowdata);
          if (data[5][rowdata.ordine] == undefined) {
            return ' - ';
          } else if (data[5][rowdata.ordine]) {
            return 'OK';
          } else {
            //console.log(data[5][rowdata.ordine]);
            return 'KO';
          }
        },
        buttonclick: (row) => {
          this.detailsCheck(row, data);
        }
      };

      let c = [];
      c.push(a);
      c.push(g);
      c.push(t);
      c.push(b);
      c.push(z);
      c.push(n);
      c.push(k);
      c.push(h);
      return c;
    },
    dataCreationCustom: function () {
      //console.log("crud: ", this);
      this.dataAdapter = new jqx.dataAdapter(source, {
        autoBind: true,
        beforeSend: (ee) => {
          this.goRowData = false;
        },
        downloadComplete: (data) => {
          //console.log(this.goRowData, "this.goRowDat")
          ////console.log(data);
          let columns = data[0].columns;
          //console.log("columns: ", columns);
          columns.push(
            this.buildAccessoryColumnsCustom(data)[0],
            this.buildAccessoryColumnsCustom(data)[3]);
          if (this.crudmodel == "GestioneIngressi") {
            columns.push(this.buildAccessoryColumnsCustom(data)[1],
              this.buildAccessoryColumnsCustom(data)[2]);
          } else if (this.crudmodel == "GestioneUscite" && this.parmscustom === 'false') {
            columns.push(this.buildAccessoryColumnsCustom(data)[4]);
          } else if (this.crudmodel == "ArchivioSpedizioni") {
            columns.push(this.buildAccessoryColumnsCustom(data)[5],
              this.buildAccessoryColumnsCustom(data)[6],
              this.buildAccessoryColumnsCustom(data)[7]
            );
            // columns.splice(14, 1);
            // columns.splice(14, 1);
          } else if (this.crudmodel == "GestioneUscite" && this.parmscustom == "prelievo_concluso") {
            columns.push(this.buildAccessoryColumnsCustom(data)[4],
              //this.buildAccessoryColumnsCustom(data)[6]
            );
            columns.splice(13, 1);
            columns.splice(13, 1);
          } else if (this.crudmodel == "GestioneGiacenze") {
            columns.push(this.buildAccessoryColumnsCustom(data)[1]);
            columns.splice(18, 1);
            columns.splice(18, 1);
          } else if (this.crudmodel == "StatisticheEntrate") {
            columns.splice(9, 1);
            columns.splice(9, 1);
          } else if (this.crudmodel == "StatisticheUscite") {
            columns.splice(11, 1);
            columns.splice(11, 1);
          }

          if (this.user.role !== 'admin' && this.crudmodel !== 'AnagraficaClienti' && this.crudmodel !== 'AnagraficaArticoli') {
            let remove = columns.findIndex(object => object.datafield === 'Edit');
            if (remove != -1) {
              columns.splice(remove, 1);
            }
            remove = columns.findIndex(object => object.datafield === 'Delete');
            if (remove != -1) {
              columns.splice(remove, 1);
            }
          }

          if (this.crudmodel === 'ManagerTrasmissioniEdi') {
            let remove = columns.findIndex(object => object.datafield === 'Edit');
            if (remove != -1) {
              columns.splice(remove, 1);
            }
            remove = columns.findIndex(object => object.datafield === 'Delete');
            if (remove != -1) {
              columns.splice(remove, 1);
            }
          }

          if (this.crudmodel == "ArchivioSpedizioni" && this.parmscustom == "false") {
            let remove = columns.findIndex(object => object.datafield === 'Edit');
            if (remove != -1) {
              columns.splice(remove, 1);
            }
          }

          if (this.crudmodel == "ArchivioSpedizioni" && this.parmscustom == "modifica") {
            let remove = columns.findIndex(object => object.datafield === 'Check');
            if (remove != -1) {
              columns.splice(remove, 1);
            }
          }

          // let gridAdapter = new jqx.dataAdapter({
          //   datafields: datafields,
          //   id: 'id',
          //   localdata: rows,
          // });
          if (this.goColumns) {
            this.columns = columns;
            this.goColumns = false;
          }
          // let rows = data[1].rows;
          this.rowsData = data[1].rows;
          this.goRowData = true;
          // let datafields = data[2].datafields;
          let maxid = data[3];
          // this.$refs.myGrid.hideloadelement();
          // this.$refs.myGrid.beginupdate();
          // this.$refs.myGrid.setOptions
          // ({
          //   //source: gridAdapter,
          //   columns: columns,
          // });
          //this.$refs.myGrid.endupdate();
          colonnegenerali = columns;
          lastid = maxid;
          fieldnotallowed = data[4];
          alldata = data;
          // this.$nextTick(() => {
          //
          // })
        }
      });
    },
    cancelBtn: function () {
      this.$refs.details.$refs.myWindow.hide();
    }
  },
  mounted: function () {
    source = {
      datatype: 'json',
      id: 'id',
      url: '/api/cruds/read?t=' + this.crudmodel + '&q=' + this.parmscustom,
      formatter: 'date', formatoptions: {srcformat: 'Y-m-d', newformat: 'Y-m-d'},
      //cache: false,
      processdata: function (data) {
        data.featureClass = "P";
        data.style = "full";
        //data.maxRows = 50;
      },
      beforeprocessing: function (data) {
        if (data[6] !== undefined) {
          source.totalrecords = data[6];
        } else {
          source.totalrecords = data[3];
        }
      },
      sort: () => {
        // update the grid and send a request to the server.
        this.$refs.myGrid.updatebounddata("sort");
      },
      filter: () => {
        // update the grid and send a request to the server.
        this.$refs.myGrid.updatebounddata("filter");
        this.$refs.myGrid.clearselection();
        //this.$refs.myGrid.updatebounddata("sort");
      }
    };
    table = this.crudmodel;
    this.dataCreationCustom();
  }
}
</script>

<style scoped>
.pac-container {
  z-index: 100000;
}
</style>



// WEBPACK FOOTER //
// resources/js/components/Crud.vue